export default __webpack_public_path__ + "static/media/vector.6e7c7089.jpg";